import React from "react";
import "./DropDownButton.css";

const styles = {
	container: {
		display: "flex",
		flexDirection: "column",
		minWidth: 235,
		padding: "8px 10px",
		whiteSpace: "nowrap",
		boxSizing: "border-box",
	},
	header: {
		width: "100%",
		borderBottom: "1px solid #DDDDDD",
		fontWeight: "bold",
		marginBottom: "8px",
		paddingBottom: "4px",
	},
	list: {
		display: "flex",
		flexDirection: "column",
		padding: "3px 0px",
	},
	listItem: {
		display: "block",
		padding: "7px 5px",
		fontWeight: "400",
		lineHeight: "1.42857143",
		color: "#333",
		cursor: "pointer",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	emptyState: {
		color: "#888",
		fontStyle: "italic",
		padding: "10px 5px",
	},
};

const DropDownFriendlyList = ({
	items = [],
	renderItem,
	onItemClick,
	width,
	title,
	emptyStateText = "(none)",
	maxItems,
}) => {
	let unpinnedShown = 0;
	const visibleItems =
		maxItems == null
			? items
			: items.filter((item) => item.pinned || unpinnedShown++ < maxItems);

	return (
		<div
			style={{
				...styles.container,
				...(width ? { minWidth: width } : {}),
			}}
		>
			{title ? <div style={styles.header}>{title}</div> : null}

			<div style={styles.list}>
				{visibleItems && visibleItems.length > 0 ? (
					visibleItems.map((item, itemIndex) => {
						const itemKey = `item_${itemIndex}`;

						if (renderItem) {
							return (
								<div
									className="DropdownListItem"
									key={itemKey}
									data-pinned={item.pinned ? "1" : undefined}
								>
									{renderItem({
										item,
										key: itemKey,
										index: itemIndex,
										onClick: () =>
											onItemClick
												? onItemClick(item, itemIndex)
												: null,
									})}
								</div>
							);
						}

						return (
							<div
								className="DropdownListItem"
								key={itemKey}
								style={styles.listItem}
								onClick={() =>
									onItemClick
										? onItemClick(item, itemIndex)
										: null
								}
							>
								{typeof item === "string"
									? item
									: item.label || item.name || item.title}
							</div>
						);
					})
				) : (
					<div style={styles.emptyState}>{emptyStateText}</div>
				)}
			</div>
		</div>
	);
};

export default DropDownFriendlyList;
